<template>
    <div class="carDialog">
        <el-dialog
            class="form-dialog row-dialog"
            :title="title"
            :visible="RwCarVisiable"
            :close-on-click-modal="false"
            :before-close="handleRwCarClose"
            :modal="false"
            width="78%"
            v-dialogDrag
        >
            <el-form
                :label-position="labelPosition"
                :model="AdmittRuleForm"
                :rules="carSchedulingDialog.AdmittRules"
                label-width="120px"
                ref="AdmittRuleForm"
                class="rowIndex"
            >
                <el-form-item
                    key="carrierName"
                    label="承运商"
                    prop="carrierName"
                    class="label-form"
                    v-model="AdmittRuleForm.carrierName"
                >
                    <otpAdvance
                        ref="carrierName"
                        :disabled="disableEdit"
                        :formData="AdmittRuleForm"
                        @clear="clearClick(AdmittRuleForm.carrierName)"
                        :prop="'carrierName'"
                        :mValue="AdmittRuleForm.carrierName"
                        :params="carSchedulingDialog.customerOrderNoCode"
                        @getAdvanceValue="getAdvanceValueLists"
                    >
                    </otpAdvance>
                </el-form-item>
                <el-form-item
                    key="procurementChannel"
                    v-if="AdmittRuleForm.carrierName"
                    v-model="AdmittRuleForm.procurementChannel"
                    label="采购渠道"
                    prop="procurementChannel"
                    value-key="id"
                    class="label-form"
                >
                    <el-select v-if="AdmittRuleForm.procurementChannelFlag" v-model="AdmittRuleForm.procurementChannel"
                        placeholder="请选择采购渠道" @change="procurementChannelChange">
                        <el-option
                            v-for="item in procurementChannelOptions"
                            :key="item.transName"
                            :label="item.transName"
                            :value="item.transType">
                        </el-option>
                    </el-select>
                    <selects v-else
                        :filterable="true"
                        :mValue="AdmittRuleForm.procurementChannel"
                        :optionNum="'OTP_TMS_PROCUREMENT_CHANNEL'"
                        :prop="'procurementChannel'"
                        @getSelectValue="getSelectValue"
                    ></selects>
                </el-form-item>
                <el-form-item
                    key="vehicleCard"
                    label="车牌"
                    prop="vehicleCard"
                    :rules="[{required: driverPropCheck, message: '车牌不能为空', trigger: 'change' }]"
                    class="label-form"
                    v-model="AdmittRuleForm.vehicleCard"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <otpAdvance
                        :formData="AdmittRuleForm"
                        :disabled="disableEdit || AdmittRuleForm.isExpressCarrier === 'Y'"
                        :prop="'vehicleCard'"
                        :mValue="AdmittRuleForm.vehicleCard"
                        @getAdvanceValue="getVehicleCardValue"
                        :params="carSchedulingDialog.controlVehicleCardLists"
                    ></otpAdvance>
                </el-form-item>
                <el-form-item
                    key="conveniently"
                    label="是否顺路带回"
                    prop="conveniently"
                    class="label-form"
                    v-show="inOutTypeName === 'IN' || inOutTypeCheck === 'IN'"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <selects
                        :disabled="convenientlyDisabledCheck"
                        :optionNum="'YES_OR_NO'"
                        :mValue="AdmittRuleForm.conveniently"
                        :prop="'conveniently'"
                        @getSelectValue="getSelectValue"
                    ></selects>
                </el-form-item>
                <el-form-item
                    key="equipmentName"
                    label="车型"
                    prop="equipmentName"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <el-input
                        clearable
                        :disabled="true"
                        v-model="AdmittRuleForm.equipmentName"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    key="equipmentTypeMapping"
                    label="伊莱克斯车型"
                    prop="equipmentTypeMapping"
                    class="label-form"
                    v-if="(AdmittRuleForm.procurementChannel && yiLaiKeSIiCheck()) || dataLists.equipmentTypeMapping"
                >
                    <selects
                        clearable
                        :mValue="AdmittRuleForm.equipmentTypeMapping"
                        :optionNum="'ELECTROLUX_CAR_TYPE'"
                        :prop="'equipmentTypeMapping'"
                        @getSelectValue="getSelectValue"
                    ></selects>
                </el-form-item>
                <el-form-item
                    key="besArriveDate"
                    label="预计到车时间"
                    prop="besArriveDate"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <el-date-picker
                        popper-class="dispatch-center-car-scheduling"
                        v-model="AdmittRuleForm.besArriveDate"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item
                    key="driver"
                    label="司机"
                    prop="driver"
                    :rules="[{ required: driverPropCheck, message: '司机不能为空', trigger: 'change' }]"
                    class="label-form"
                    v-model="AdmittRuleForm.driver"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <otpAdvance
                        :formData="AdmittRuleForm"
                        :disabled="disableEdit || AdmittRuleForm.isExpressCarrier === 'Y'"
                        :mValue="AdmittRuleForm.driver"
                        :prop="'driver'"
                        @getAdvanceValue="getDriverValue"
                        :params="carSchedulingDialog.controlDriverLists"
                    ></otpAdvance>
                </el-form-item>
                <el-form-item
                    key="driverContactWay"
                    label="电话"
                    prop="driverContactWay"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <el-input
                        clearable
                        :disabled="true"
                        v-model.trim="AdmittRuleForm.driverContactWay"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    key="totalTargetCost"
                    label="目标成本(元)"
                    class="label-form"
                    v-if="
                        AdmittRuleForm.procurementChannel &&
                        siteType === '00'
                    "
                >
                    <el-input
                        clearable
                        disabled
                        v-model.trim="AdmittRuleForm.totalTargetCost"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    key="transportationIncome"
                    label="运输收入(元)"
                    prop="transportationIncome"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel === '00'"
                >
                    <el-input
                        clearable
                        v-model.trim="AdmittRuleForm.transportationIncome"
                        placeholder=" 当收入为合同外时，必填"
                        @blur="
                            transportationIncomeBlur(
                                AdmittRuleForm.transportationIncome
                            )
                        "
                        size="medium"
                    ></el-input>
                    <div v-show="fetchTransportationIncome && showTransportationIncomeTipBox" class="transportationIncome-tip">运输单已发起事业部合同外费用审批，运输收入:{{fetchTransportationIncome}}</div>
                </el-form-item>
                <el-form-item
                    key="transportationCost"
                    label="运输成本(元)"
                    prop="transportationCost"
                    class="label-form"
                    v-if="
                        AdmittRuleForm.procurementChannel &&
                        ![
                            '10',
                            '20',
                            '40',
                            '42',
                            '120',
                            '171',
                            '190',
                            '200',
                            '210',
                        ].includes(AdmittRuleForm.procurementChannel)
                    "
                >
                    <el-input
                        clearable
                        placeholder="请按实际报价填写"
                        :disabled="transportationCostDisabled"
                        @blur="
                            transportationCostBlur(
                                AdmittRuleForm.transportationCost
                            )
                        "
                        v-model.trim="AdmittRuleForm.transportationCost"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    key="payMethod"
                    label="预付方式"
                    prop="payMethod"
                    class="label-form"
                    v-if="
                        AdmittRuleForm.procurementChannel &&
                        ![
                            '10',
                            '20',
                            '40',
                            '42',
                            '120',
                            '171',
                            '190',
                            '200',
                            '210',
                        ].includes(AdmittRuleForm.procurementChannel)
                    "
                >
                    <selects
                        clearable
                        :mValue="AdmittRuleForm.payMethod"
                        :optionNum="'SYS_TMS_PAY_METHOD'"
                        :prop="'payMethod'"
                        @getSelectValue="getPayInAdvanceSelectValue"
                        @clear="clearPayMethodLits(AdmittRuleForm.payMethod)"
                    ></selects>
                </el-form-item>
                <el-form-item
                    key="prepaidAmount"
                    label="预付金额(元)"
                    prop="prepaidAmount"
                    class="label-form"
                    v-if="
                        AdmittRuleForm.procurementChannel &&
                        ![
                            '10',
                            '20',
                            '40',
                            '42',
                            '120',
                            '171',
                            '190',
                            '200',
                            '210',
                        ].includes(AdmittRuleForm.procurementChannel)
                    "
                >
                    <el-input
                        @clear="
                            prepaidAmountClear(AdmittRuleForm.prepaidAmount)
                        "
                        @blur="changeBlur(AdmittRuleForm.prepaidAmount)"
                        ref="isPrepaidAmount"
                        clearable
                        v-model.trim="AdmittRuleForm.prepaidAmount"
                        size="medium"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item
                    key="infoFee"
                    label="信息费用(元)"
                    prop="infoFee"
                    class="label-form"
                    v-if="
                        AdmittRuleForm.procurementChannel &&
                        ![
                            '10',
                            '20',
                            '40',
                            '42',
                            '120',
                            '171',
                            '190',
                            '200',
                            '210',
                        ].includes(AdmittRuleForm.procurementChannel)
                    "
                >
                    <el-input
                        clearable
                        @clear="infoFeeClear(AdmittRuleForm.infoFee)"
                        @blur="changeInfoFeeBlur(AdmittRuleForm.infoFee)"
                        v-model.trim="AdmittRuleForm.infoFee"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    key="taxRateLists"
                    label="现汇税率(%)"
                    prop="taxRate"
                    class="label-form"
                    v-if="
                        AdmittRuleForm.procurementChannel &&
                        ![
                            '10',
                            '20',
                            '40',
                            '42',
                            '120',
                            '171',
                            '190',
                            '200',
                            '210',
                        ].includes(AdmittRuleForm.procurementChannel)
                    "
                >
                    <otpAdvance
                        :mValue="AdmittRuleForm.taxRate.toString()"
                        :prop="'taxRate'"
                        @getAdvanceValue="getTaxRateValue"
                        :params="carSchedulingDialog.taxRateLists"
                    >
                    </otpAdvance>
                </el-form-item>
                <el-form-item
                    key="dmsFlag"
                    label="是否串点计费"
                    prop="dmsFlag"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <selects
                        :disabled="isDmsFlagDisabled"
                        :mValue="
                            procurementChannelList.includes(
                                this.AdmittRuleForm.procurementChannel
                            )
                                ? '1'
                                : '0'
                        "
                        :optionNum="'YES_OR_NO'"
                        :prop="'dmsFlag'"
                        @getSelectValue="getSelectValue"
                    ></selects>
                </el-form-item>
                <el-form-item
                    key="remark"
                    label="备注"
                    prop="remark"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <el-input
                        class="exception-mark"
                        type="textarea"
                        maxlength="50"
                        show-word-limit
                        autosize
                        clearable
                        v-model.trim="AdmittRuleForm.remark"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    key="exceptionType"
                    label="装载过低异常类型"
                    prop="exceptionType"
                    class="label-form"
                    :rules="[{ required: loadRateHalf==='lesser', message: '装载过低异常类型', trigger: 'change' }]"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <selects
                        :mValue="AdmittRuleForm.exceptionType"
                        :optionNum="'EXCEPTION_TYPE'"
                        :prop="'exceptionType'"
                        @getSelectValue="getExceptionValue"
                    ></selects>
                </el-form-item>
                <el-form-item
                    key="exceptionMark"
                    label="装载过低异常备注"
                    prop="exceptionMark"
                    class="label-form"
                    :rules="[{ required: loadRateHalf==='lesser', message: '请填写装载过低异常备注', trigger: 'change' }]"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <el-input
                        class="exception-mark"
                        type="textarea"
                        maxlength="100"
                        show-word-limit
                        autosize
                        clearable
                        v-model.trim="AdmittRuleForm.exceptionMark"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    key="deviceNo"
                    label="设备号"
                    class="label-form"
                    v-if="
                        ['10', '42', '190', '200', '210'].includes(
                            AdmittRuleForm.procurementChannel
                        )
                    "
                >
                    <el-input
                        :disabled="true"
                        v-model.trim="AdmittRuleForm.deviceNo"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    key="vehicleScheduleName"
                    label="班次"
                    prop="vehicleScheduleName"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                    v-model="AdmittRuleForm.vehicleScheduleName"
                >
                    <otpAdvance
                        :formData="AdmittRuleForm"
                        :prop="'vehicleScheduleName'"
                        :mValue="AdmittRuleForm.vehicleScheduleName"
                        :params="carSchedulingDialog.vehicleScheduleNames"
                        @getAdvanceValue="getSelectValue"
                    >
                    </otpAdvance>
                </el-form-item>
                <el-form-item
                    key="oilcardPayAmount"
                    label="油卡金额(元)"
                    prop="oilcardPayAmount"
                    class="label-form"
                    v-if="
                        AdmittRuleForm.procurementChannel &&
                        AdmittRuleForm.procurementChannel === '00'
                    "
                >
                    <el-input
                        clearable
                        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                        v-model.trim="AdmittRuleForm.oilcardPayAmount"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    key="transportType"
                    label="运输方式"
                    prop="transportType"
                    value-key="id"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                    v-model="AdmittRuleForm.transportType"
                >
                    <selects
                        :filterable="true"
                        :mValue="AdmittRuleForm.transportType"
                        :optionNum="'SYS_TMS_TRANSPORT_TYPE'"
                        :prop="'transportType'"
                        @getSelectValue="getSelectValue"
                    ></selects>
                </el-form-item>
                <el-form-item
                    key="planRemark"
                    label="排车计划要求"
                    prop="planRemark"
                    class="label-form"
                    v-if="isPlanArrange"
                >
                    <el-input
                        clearable
                        v-model.trim="AdmittRuleForm.planRemark"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    key="dispatchType"
                    label="调度类型"
                    prop="dispatchType"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel && isPlanArrange"
                >
                    <selects
                        :mValue="AdmittRuleForm.dispatchType"
                        :optionNum="'DISPATCH_TYPE'"
                        :prop="'dispatchType'"
                        @getSelectValue="getdispatchTypeValue"
                    ></selects>
                </el-form-item>
                <el-form-item
                    key="whNames"
                    label="提货仓"
                    prop="whName"
                    class="label-form"
                    v-if="
                        AdmittRuleForm.procurementChannel &&
                        AdmittRuleForm.dispatchType === '2' &&
                        isPlanArrange
                    "
                >
                    <otpAdvance
                        :formData="AdmittRuleForm"
                        :prop="'whName'"
                        :mValue="AdmittRuleForm.whName"
                        :params="carSchedulingDialog.whNames"
                        @getAdvanceValue="getSelectValue"
                    >
                    </otpAdvance>
                </el-form-item>
                <el-form-item
                    key="onWayContactCategory"
                    label="在途联系类别"
                    prop="onWayContactCategory"
                    class="label-form"
                    v-if="intranetInformationFlag"
                >
                    <el-select
                        v-model="AdmittRuleForm.onWayContactCategory"
                        :disabled="informationFlag"
                        placeholder="请选择在途联系类别"
                    >
                        <el-option
                            v-for="item in onWayContactCategoryList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    key="onWayContactName"
                    label="在途联系人"
                    prop="onWayContactName"
                    class="label-form"
                    v-if="intranetInformationFlag"
                >
                    <el-input
                        clearable
                        :disabled="informationFlag"
                        v-model.trim="AdmittRuleForm.onWayContactName"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    key="onWayContactPhone"
                    label="在途联系人电话"
                    prop="onWayContactPhone"
                    class="label-form"
                    v-if="intranetInformationFlag"
                >
                    <el-input
                        clearable
                        :disabled="informationFlag"
                        v-model.trim="AdmittRuleForm.onWayContactPhone"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    key="transUnitName"
                    label="会计主体"
                    prop="transUnitName"
                    class="label-form"
                    v-model="AdmittRuleForm.transUnitName"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <el-input
                        v-if="siteType === '00'"
                        :disabled="true"
                        v-model.trim="AdmittRuleForm.transUnitName"
                        size="medium"
                    ></el-input>
                    <otpAdvance
                        v-else
                        :disabled="transUnitNameDisabled"
                        :formData="AdmittRuleForm"
                        :prop="'transUnitName'"
                        :mValue="AdmittRuleForm.transUnitName"
                        @getAdvanceValue="getVehicleCardValue"
                        :params="carSchedulingDialog.transUnitNames"
                    ></otpAdvance>
                </el-form-item>
                <el-form-item
                    key="shippingType"
                    class="label-form"
                    label="发运类型"
                    prop="shippingType"
                    v-if="AdmittRuleForm.procurementChannel && whiteListCheck()"
                >
                    <selects
                        :optionNum="'TMS_SHIPPING_TYPE'"
                        :mValue="AdmittRuleForm.shippingType"
                        @getSelectValue="getSelectValue"
                        placeholder="请选择发运类型"
                        :prop="'shippingType'"
                    ></selects>
                </el-form-item>
                    <el-form-item
                    key="tyOutputTime"
                    label="预约到厂日期"
                    prop="tyOutputTime"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel && isTy"
                >
                    <el-date-picker
                        popper-class="dispatch-center-car-scheduling"
                        v-model="AdmittRuleForm.tyOutputTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间"
                        @blur="timeChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item
                    key="tyCarTypeName"
                    class="label-form"
                    label="统一车型"
                    prop="tyCarTypeName"
                    v-if="AdmittRuleForm.procurementChannel && isTy"
                >
                    <selects
                        :optionNum="'TYSP_WBKH_TYPE'"
                        :mValue="AdmittRuleForm.tyCarTypeName"
                        @getSelectValue="getSelectValue"
                        placeholder="请选择统一车型"
                        :prop="'tyCarTypeName'"
                    ></selects>
                </el-form-item>
                <el-form-item key="orderNo" v-if="(disableEdit || this.isSiteWhiteList) && AdmittRuleForm.procurementChannel" label="调车单号" prop="orderNo"
                :rules="[{ required: siteType === '00', message: '调车单号不能为空', trigger: 'change' }]">
                    <el-input
                        v-model="AdmittRuleForm.orderNo"
                        :readonly="true"
                        :disabled="disableEdit || (siteType === '00' && orderNoList.length === 1 && dataLists.ntpManagerOrderNo)"
                        autocomplete="off"
                        placeholder="请选择调车单号"
                    >
                    <i
                        slot="suffix"
                        class="el-input__icon el-icon-circle-close"
                        v-if="!(disableEdit || (siteType === '00' && orderNoList.length === 1 && dataLists.ntpManagerOrderNo))"
                        @click="clearOrderNo"
                    ></i>
                    <el-button
                        slot="append"
                        icon="el-icon-search"
                        :disabled="disableEdit || (siteType === '00' && orderNoList.length === 1 && dataLists.ntpManagerOrderNo)"
                        @click="openAdvanceDialog"
                    ></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item
                    key="forceChuanDian"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel && forceChuanDianShowCheck"
                >
                    <el-checkbox v-model="AdmittRuleForm.forceChuanDian" :disabled="forceChuanDianDisabled" :true-label="1" :false-label="0">直控线路串点计费模式</el-checkbox>
                </el-form-item>
                <el-form-item
                    key="ztbTransportFlag"
                    label="是否直通宝转运"
                    prop="ztbTransportFlag"
                    class="label-form"
                    v-if="AdmittRuleForm.shippingType === '0'"
                >
                    <el-select
                        v-model="AdmittRuleForm.ztbTransportFlag"
                        placeholder="请选择是否直通宝转运"
                    >
                        <el-option
                            v-for="item in ztbTransportFlagList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="handleRwCarClose">取 消</el-button>
                <el-button
                    type="primary"
                    :loading="saveLoading"
                    :disabled="isButtonDisabled"
                    @click="AdmittOk('AdmittRuleForm')"
                    >保 存</el-button
                >
            </div>

            <advanceDialog
                ref="advanceDialog"
                v-model="AdmittRuleForm.orderNo"
                :mValue="AdmittRuleForm.orderNo"
                :formData="AdmittRuleForm"
                :params="carSchedulingDialog.advanceDialogConfig"
                @confirm="confirm"
            ></advanceDialog>
            <!-- 直控线路使用非直控运力原因填写 -->
            <reason-dialog
                :reasonDialogVisible.sync="reasonDialogVisible"
                @handleSure="handleReasonDialogSure"
            ></reason-dialog>

        </el-dialog>
    </div>
</template>

<script>
import { getDispathOrderEdit } from '../../api/dispatchOrder';
import {
    getNewLicensePlate, getNewDriverName, getWhiteListApi, getSearchBySupplier, getInvoiceUnitName,
    getTargetCost, isLingDanApi, getOrderNo, isSiteWhiteListApi, getIsControlTransportToOpt, getProcurementChannelListApi, judgeExpressApi, getIsDirectCarrier,
    verifyLoadingRate, getNtpManagerOrderComputerCostApi, getOutContractIncomeApi
} from '../../api/carSchedulingDialog';
import carSchedulingDialog from './carSchedulingDialog/carSchedulingDialog';
import ReasonDialog from './ReasonDialog';
import otpAdvance from '@/components/lots/otpAdvance';
import selects from '@/components/lots/otpSelect';
import { dictWithUrl } from '@/components/lots/api.js';
import _ from 'lodash';

export default {
    components: {
        selects, otpAdvance, advanceDialog: () => import('@/components/lots/otpAdvanceDialog'), ReasonDialog
    },
    props: {
        isPlanArrange: {// 计划排车标识
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '排车调度'
        },
        labelPosition: {
            type: String,
            default: 'right'
        },
        RwCarVisiable: {
            type: Boolean,
            default: false
        },
        dataLists: {
            type: Object,
            default () {
                return {};
            }
        },
        isConveniently: {
            type: Boolean,
            default: true
        },
        inOutType: {
            type: String,
            default () {
                return '';
            }
        },
        taskDataList: {
            type: Array,
            default () {
                return [];
            }
        },
        dispatchSaveFlag: {
            type: Boolean,
            default: true // 算法排车
        },
        checkDispatch: { // 是否开启排车承运商限制
            type: Boolean,
            default: false
        },
        disableEdit: { // 是否开启承运商、车牌、司机的可编辑模式
            type: Boolean,
            default: false
        },
        isAlgorithmicType: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            carSchedulingDialog,
            siteType: '',
            isDmsFlagDisabled: true,
            isConvenientlyLists: true,
            isSiteWhiteList: false, // 开启自调车编码填写
            driverOptions: [],
            LicensePlateOptions: [],
            businessOptions: [],
            NTPInfo: {
                NTPDriverName: '',
                NTPDriverCode: '',
                NTPCarLicense: ''
            },
            onWayContactCategoryList: [
                {
                    value: '1',
                    label: '司机'
                }, {
                    value: '2',
                    label: '供应商'
                }
            ],
            ztbTransportFlagList: [
                { value: 1, label: '是' },
                { value: 0, label: '否' }
            ],
            AdmittRuleForm: {
                supplierCode: '',
                routeNoList: [],
                carrierName: '',
                dmsFlag: '',
                procurementChannel: '',
                conveniently: '',
                vehicleCard: '',
                equipmentName: '',
                driver: '',
                driverContactWay: '',
                besArriveDate: '',
                payMethod: '',
                transportationCost: '',
                prepaidAmount: '',
                taxRate: '',
                remark: '',
                driverIdentity: '',
                infoFee: '',
                equipmentType: '',
                exceptionType: '',
                exceptionMark: '',
                deviceNo: '',
                vehicleScheduleName: '',
                companyCode: '',
                oilcardPayAmount: '',
                planRemark: '',
                dispatchType: '',
                whName: '',
                transportType: '00',
                transUnitName: '',
                transUnitCode: '',
                paymentTerms: '',
                transportContractNo: '',
                taskDataList: [],
                orderNo: '',
                updateShippingTypeTaskNos: [],
                shippingType: '',
                transportationIncome: '', // 运输收入
                onWayContactName: '', // 在途联系类别
                onWayContactCategory: '', // 在途联系人
                onWayContactPhone: '', // 在途联系人电话
                totalTargetCost: '', // 目标成本
                equipmentTypeMapping: '', // 伊莱克斯车型
                forceChuanDian: 0,
                checkResource: false, // 套牌车卡控
                isExpressCarrier: '', // 是否快递公司
                expressCompanyCode: '', // 快递公司编码
                expressCompanyName: '', // 快递公司名称
                ztbTransportFlag: 1, // 是否直通宝转运
                directlyControlledRecord: {
                    directControlTransportCapacityFlag: false
                },
                professionalCompanyList: [], // tk单专司集合
                siteCodeList: [],
                procurementChannelFlag: false,
                supplierStatus: '30',
                businessTypeStatus: '5',
                switchSrm: null,
                forwardNtpDeploy: null,
                natureType: '', //  0表示“个体车抢单”，1表示“承运商抢单”
                propertyNature: '',
                tyOutputTime: '',
                tyCarTypeName: '',
                driverPrintTemplate: '',
                taskNoList: [], // TK单号集合
                standardShippingType: ''// 校验发运类型
            },
            prepaidAmount: '',
            taxRate: '',
            orderNoList: [],
            isButtonDisabled: false,
            saveLoading: false,
            intranetInformationFlag: false,
            ntpManagerReverseProcessFlag: true,
            informationFlag: false,
            unit: {}, // 自调车会计主体
            inOutTypeCheck: '', // 检验排车的TK单类型，用于是否顺路带回的判断IN显示
            siteCodeWhiteList: [], // 多仓提货补贴根据服务平台开启
            procurementChannelList: ['42', '190', '200'], // 默认串点计费标识，车队长合车/城配长合车/送装供应商
            procurementChannelWhiteList: ['42', '190', '200'], // 获取采购渠道集合,
            reasonDialogVisible: false,
            procurementChannelOptions: [], // 采购渠道集合
            forceChuanDianSiteCodeList: [], // 直控线路串点计费模式服务平台白名单
            loadRateHalf: 'normal', // 装载率是否低于50%
            fetchTransportationIncome: '', // 接口返回审批费用
            showTransportationIncomeTipBox: true,
            transportationCostDisabledFlag: true // 运输成本禁用编辑标识
        };
    },
    methods: {
        // 直控转非直控线路原因填写
        handleReasonDialogSure (data) {
            this.reasonDialogVisible = false;
            this.AdmittRuleForm.directlyControlledRecord = data;
            this.continueAdmittOk();
        },
        // 承运商抢单时(natureType = 1)，自动带出会计主体并置灰
        setTransUnitName (data) {
            this.AdmittRuleForm.natureType = data.natureType || '';
            if (+data.natureType === 1) {
                this.AdmittRuleForm.transUnitName = data.accountName;
                this.AdmittRuleForm.transUnitCode = data.accountCode;
                this.AdmittRuleForm.transportContractNo = data.contractCode;
            }
        },
        // 信息费用
        changeInfoFeeBlur (infoFee) {
            if (infoFee === undefined || infoFee === '') {
                this.isButtonDisabled = false;
            } else {
                const reg = /^(([1-9][0-9]{0,4})([.][0-9]{0,2})?|100000|100000.0|100000.00|0.0|0.00|0)$/;
                if (!reg.test(infoFee)) {
                    this.isButtonDisabled = true;
                    return this.$message.warning('请输入数字，可为0，最多支持2位小数；最高支持十万');
                } else {
                    this.isButtonDisabled = false;
                }
            }
        },
        // 预付金额
        changeBlur (prepaidAmount) {
            const reg = /^(([1-9][0-9]{0,4})([.][0-9]{0,2})?|100000|100000.0|100000.00|0.0|0.00|0)$/;
            if (Number(prepaidAmount) > Number(this.AdmittRuleForm.transportationCost)) {
                this.$message.warning('预付金额不可大于运输成本');
                this.isButtonDisabled = true;
                return false;
            } else {
                this.isButtonDisabled = false;
            }
            if (!reg.test(prepaidAmount) && prepaidAmount) {
                this.isButtonDisabled = true;
                return this.$message.warning('请输入数字，可为0，最多支持2位小数；最高支持十万');
            }
        },
        prepaidAmountClear (prepaidAmount) {
            if (prepaidAmount === '' && this.AdmittRuleForm.payMethod) {
                this.$message.warning('请填写预付金额');
                this.isButtonDisabled = true;
                return false;
            }
            if (!prepaidAmount) {
                this.isButtonDisabled = false;
            }
        },
        infoFeeClear (infoFee) {
            if (!infoFee) {
                this.isButtonDisabled = false;
            }
        },
        // 运输收入
        transportationIncomeBlur (transportationIncome) {
            this.isButtonDisabled = false;
            this.showTransportationIncomeTipBox = true;
            this.$refs.AdmittRuleForm.validateField('transportationIncome', (errorMessage) => {
                this.showTransportationIncomeTipBox = !errorMessage;
            });
        },
        // 运输成本
        transportationCostBlur (transportationCost) {
            if ((Number(this.AdmittRuleForm.transportationCost)) < (Number(this.AdmittRuleForm.prepaidAmount))) {
                this.$message.warning('预付金额不可大于运输成本');
                this.isButtonDisabled = true;
                return false;
            } else {
                this.isButtonDisabled = false;
            }
        },
        // 车牌基础数据
        getVehicleCardValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
        },
        // 司机基础数据
        getDriverValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
            this.AdmittRuleForm.onWayContactCategory = data.onWayContactCategory ? data.onWayContactCategory : '';
            this.AdmittRuleForm.onWayContactName = data.onWayContactName ? data.onWayContactName : '';
            this.AdmittRuleForm.onWayContactPhone = data.onWayContactPhone ? data.onWayContactPhone : '';
            this.informationFlag = false;
            if (!data.onWayContactCategory && !data.onWayContactName && !data.onWayContactPhone) {
                this.setInformationEntry(this.AdmittRuleForm.propertyNature);
            } else {
                // 是否手填/新在途联系人
                this.AdmittRuleForm.newOnWayContact = false;
                this.intranetInformationFlag = true;
                this.informationFlag = true;
            }
        },
        // 现汇税率基础数据
        getTaxRateValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
            this.taxRate = (data.taxRate).toString();
        },
        // 承运商基础数据
        async getAdvanceValueLists (data) {
            this.$refs.AdmittRuleForm.resetFields();
            this.clearOrderNo();
            if (this.checkDispatch && this.dispatchSaveFlag) {
                const res = await getIsDirectCarrier({ supplierCode: data.carrierCode });
                if (res && +res.code === 0 && +res.data.isControlTransport !== 1) {
                    this.AdmittRuleForm.carrierName = '';
                    this.AdmittRuleForm.carrierCode = '';
                    return this.$message.warning('算法排车只能选择直控运力的承运商');
                }
            }
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
            if (this.AdmittRuleForm.procurementChannelFlag) {
                this.siteType = '';
                this.AdmittRuleForm.procurementChannel = '';
                data.supplierCode && this.getProcurementChannelList(data.supplierCode);
            } else {
                this.procurementChannelChange(data.transType);
            }

            // 快递承运商校验
            if (!this.disableEdit && !this.isPlanArrange) { // 网络调车排车、计划排车不需要调这个接口
                await this.getJudgeExpress();
            }
            // 不是快递承运商时，默认调车牌、司机接口
            if (this.AdmittRuleForm.isExpressCarrier !== 'Y') {
                this.getLicensePlateLists();
                this.getDriverNameLists();
            }
            this.intranetInformationFlag = false;
        },
        // 班次基础数据
        getVehicleScheduleName (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
        },
        getData (data) {
            getDispathOrderEdit(data).then(res => { });
        },
        // 预付方式
        clearPayMethodLits (payMethod) {
            if (payMethod === '') {
                this.AdmittRuleForm.prepaidAmount = '';
            }
        },
        // 预付方式数据字典
        getPayInAdvanceSelectValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
            const prepaidAmountLists = this.AdmittRuleForm.prepaidAmount;
            if (data.payMethod && prepaidAmountLists === undefined) {
                this.isButtonDisabled = true;
                this.$message.warning('请填写预付金额');
            } else {
                this.isButtonDisabled = false;
            }
        },
        // 获取采购渠道
        getProcurementChannelList (supplierCode) {
            const params = {
                supplierCode,
                professionalCompanyList: this.professionalCompanyList,
                taskNoList: this.taskNoList
            };
            this.procurementChannelOptions = [];
            getProcurementChannelListApi(params).then(res => {
                if (res && +res.code === 0) {
                    this.procurementChannelOptions = res.data;
                    if (this.procurementChannelOptions.length === 1) { // 只返回一种采购渠道时，直接作为默认值
                        this.procurementChannelChange(this.procurementChannelOptions[0].transType);
                    } else if (this.procurementChannelOptions.length === 2) {
                        this.procurementChannelOptions.forEach(item => {
                            item.transType !== '00' && this.procurementChannelChange(item.transType);
                        });
                    }
                }
            });
        },
        // 采购渠道值变化
        procurementChannelChange (procurementChannel) {
            this.$refs.AdmittRuleForm.clearValidate();
            this.siteType = procurementChannel;
            this.AdmittRuleForm.procurementChannel = procurementChannel;
            // 车队长合车/城配长合车/送装供应商增加特殊标识
            this.AdmittRuleForm.dmsFlag = this.procurementChannelList.includes(procurementChannel) ? '1' : '0';
            // 匹配零担线路配置
            if (this.whiteListCheck()) {
                this.isLingDan();
            }

            // 退货入库订单且 城配长合车190或送装供应商200时，标识默认展示为“是”
            if ((this.inOutType === 'IN' || this.inOutTypeCheck === 'IN') && ['190', '200'].includes(procurementChannel)) {
                if (!this.dataLists.conveniently && +this.dataLists.conveniently !== 0) {
                    this.AdmittRuleForm.conveniently = '1';
                }
                if (this.dataLists.conveniently) {
                    this.AdmittRuleForm.conveniently = String(this.dataLists.conveniently);
                }
            } else {
                this.AdmittRuleForm.conveniently = this.dataLists.conveniently ? String(this.dataLists.conveniently) : '0';
            }

            // 当是承运商抢单时，不需要再获取会计主体
            if (this.transUnitNameDisabled) {
                return false;
            }
            ['transUnitName', 'transUnitCode', 'paymentTerms', 'transportContractNo'].forEach(key => {
                this.AdmittRuleForm[key] = '';
            });
            // 切换采购渠道默认清空必填校验，如果包括190、200就按条件发请求查装载率校验
            this.loadRateHalf = 'normal';
            this.judgeLoadRateLessHalf();

            // 会计主体 判断是否为自调车
            if (procurementChannel === '00') {
                ['transUnitName', 'transUnitCode'].forEach(key => {
                    this.AdmittRuleForm[key] = this.unit[key];
                });
            } else if (this.AdmittRuleForm.supplierCode) {
                if (this.taskDataList.length) {
                    const taskDataList = this.taskDataList.map(item => {
                        return {
                            siteCode: item.siteCode,
                            companyCode: item.companyCode,
                            businessType: item.businessType,
                            suppliersCode: this.AdmittRuleForm.supplierCode
                        };
                    });
                    this.AdmittRuleForm.taskDataList = _.unionWith(taskDataList, (item1, item2) => {
                        return item1.siteCode === item2.siteCode && item1.companyCode === item2.companyCode && item1.businessType === item2.businessType;
                    });
                } else { // 解决计划排车修改时没有运输单时的问题
                    this.AdmittRuleForm.taskDataList = [{ suppliersCode: this.AdmittRuleForm.supplierCode }];
                }
                this.transUnitNameMethods();
            }
        },
        // 获取快递公司标识
        async getJudgeExpress () {
            this.AdmittRuleForm.isExpressCarrier = '';
            const params = {
                carrierCode: this.AdmittRuleForm.carrierCode,
                carrierName: this.AdmittRuleForm.carrierName,
                transportList: this.taskDataList
            };
            await judgeExpressApi(params).then(res => {
                if (res && +res.code === 0) {
                    ['isExpressCarrier', 'expressCompanyCode', 'expressCompanyName'].forEach(key => {
                        this.AdmittRuleForm[key] = res.data[key] || '';
                    });
                }
            });
        },
        getTotalTargetCost () {
            const params = {
                dispatchNo: this.dataLists.dispatchNo || '',
                taskNos: this.dataLists.dispatchNo ? [] : this.taskDataList.map(i => i.taskNo)
            };
            getTargetCost(params).then(res => {
                if (res && res.code === '0' && res.data) {
                    this.AdmittRuleForm.totalTargetCost = res.data.totalTargetCost || '';
                }
            });
        },
        getExceptionValue (data) {
            this.AdmittRuleForm.exceptionType = data.exceptionType;
        },
        // 数据字典
        getSelectValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
        },
        getdispatchTypeValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
            this.AdmittRuleForm.whName = '';
            this.AdmittRuleForm.whCode = '';
        },
        // 会计主体请求接口
        transUnitNameMethods () {
            const params = {
                pageSize: 10,
                pageNo: 1,
                taskDataList: this.AdmittRuleForm.taskDataList
            };
            getInvoiceUnitName(params).then(res => {
                if (res && +res.code === 0 && res.data.list.length === 1) {
                    const data = res.data.list[0];
                    ['paymentTerms', 'transportContractNo'].forEach(key => {
                        this.AdmittRuleForm[key] = data[key];
                    });
                    this.AdmittRuleForm.transUnitName = data.accountName;
                    this.AdmittRuleForm.transUnitCode = data.accountCode;
                }
            });
        },
        // 调车单号基础数据请求
        getOrderNoLists (driverNo) {
            if (!driverNo) return;
            const params = {
                driverCodes: [driverNo],
                carLicenses: [this.AdmittRuleForm.vehicleCard], // 车牌
                supplierCodes: [this.AdmittRuleForm.carrierCode] // 承运商编码
            };
            getOrderNo(params).then(res => {
                if (res && +res.code === 0) {
                    this.orderNoList = res.data.list || [];
                    if (this.orderNoList.length === 1) {
                        const data = this.orderNoList[0];
                        this.AdmittRuleForm.orderNo = data.orderNo;
                        this.NTPInfo.NTPDriverName = data.driverName;
                        this.NTPInfo.NTPDriverCode = data.driverCode;
                        this.NTPInfo.NTPCarLicense = data.carLicense;
                        this.setTransUnitName(data);
                        this.getTransportationCost(data);
                    }
                }
            });
        },
        // 车牌基础数据接口请求
        getLicensePlateLists (data) {
            const params = {
                pageSize: 10,
                pageNo: 1,
                supplierCode: this.AdmittRuleForm.supplierCode,
                siteCodeList: this.AdmittRuleForm.siteCodeList,
                checkResource: this.AdmittRuleForm.checkResource
            };
            getNewLicensePlate(params).then(res => {
                if (res.data && res.data.list && res.data.list.length === 1 && !res.data.list[0].used) {
                    const data = res.data.list[0];
                    this.AdmittRuleForm.vehicleCard = data.licensePlateNo;
                    this.AdmittRuleForm.cargoVolumeStr = data.maxVolume;
                    this.AdmittRuleForm.equipmentName = data.carTypeNameCn;
                    this.AdmittRuleForm.equipmentType = data.carType;
                    this.AdmittRuleForm.deviceNo = data.deviceNo;
                }
            });
        },
        // 基础数据司机查询接口
        getDriverNameLists (data) {
            const params = {
                pageSize: 10,
                pageNo: 1,
                supplierCode: this.AdmittRuleForm.supplierCode,
                siteCodeList: this.AdmittRuleForm.siteCodeList,
                checkResource: this.AdmittRuleForm.checkResource
            };
            getNewDriverName(params)
                .then(res => {
                    if (res.data && res.data.list && res.data.list.length === 1 && !res.data.list[0].used) {
                        const data = res.data.list[0];
                        this.AdmittRuleForm.driver = data.driverName;
                        this.AdmittRuleForm.driverContactWay = data.driverPhone;
                        this.AdmittRuleForm.driverIdentity = data.driverIdCard;
                        this.AdmittRuleForm.driverNo = data.driverCode;
                        if (!data.onWayContactCategory && !data.onWayContactName && !data.onWayContactPhone) {
                            this.AdmittRuleForm.onWayContactCategory = data.onWayContactCategory ? data.onWayContactCategory : '';
                            this.AdmittRuleForm.onWayContactName = data.onWayContactName ? data.onWayContactName : '';
                            this.AdmittRuleForm.onWayContactPhone = data.onWayContactPhone ? data.onWayContactPhone : '';
                            this.informationFlag = false;
                            this.setInformationEntry(this.AdmittRuleForm.propertyNature);
                        } else {
                            this.AdmittRuleForm.onWayContactCategory = data.onWayContactCategory;
                            this.AdmittRuleForm.onWayContactName = data.onWayContactName;
                            this.AdmittRuleForm.onWayContactPhone = data.onWayContactPhone;
                            // 是否手填/新在途联系人
                            this.AdmittRuleForm.newOnWayContact = false;
                            this.intranetInformationFlag = true;
                            this.informationFlag = true;
                        }
                    }
                })
                .finally(() => {
                    this.isSiteWhiteList && this.getOrderNoLists(this.AdmittRuleForm.driverNo);
                });
        },
        // 司机在途信息录入->当前运输单的服务平台是否存在于白名单->如果存在于白名单并且承运商主体是法人->将司机在途信息带入
        setInformationEntry (propertyNature) {
            getWhiteListApi({ type: 'ON_WAY_CONTACT' }).then(res => {
                let flag = null;
                if (this.dataLists.siteCode) {
                    flag = res.data.includes(this.dataLists.siteCode);
                    if (flag) {
                        if (propertyNature === 1) {
                            this.intranetInformationFlag = flag;
                            // 是否手填/新在途联系人
                            this.AdmittRuleForm.newOnWayContact = true;
                        } else {
                            this.intranetInformationFlag = false;
                        }
                    }
                } else if (this.taskDataList.length) {
                    const list = this.taskDataList.map(item => item.siteCode);
                    for (let i = 0; i <= list.length; i++) {
                        flag = res.data.includes(list[i]);
                        if (flag) {
                            if (propertyNature === 1) {
                                this.intranetInformationFlag = flag;
                                // 是否手填/新在途联系人
                                this.AdmittRuleForm.newOnWayContact = true;
                                return;
                            } else {
                                this.intranetInformationFlag = false;
                            }
                        } else {
                            this.intranetInformationFlag = flag;
                        }
                    }
                }
            });
        },
        handleRwCarClose () {
            this.$emit('update:RwCarVisiable', false);
        },
        AdmittOk (formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    const AdmittRuleForm = this.AdmittRuleForm;
                    if (!this.disableEdit) {
                        if ((this.siteType === '00' || (this.siteType !== '00' && AdmittRuleForm.orderNo)) && this.isSiteWhiteList && this.orderNoList.length) {
                            const driverInfoIsError = AdmittRuleForm.driver !== this.NTPInfo.NTPDriverName || AdmittRuleForm.driverNo !== this.NTPInfo.NTPDriverCode;
                            if (driverInfoIsError) {
                                return this.$message.warning('司机信息与调车单号信息不一致!');
                            }
                        }
                    }
                    if ((this.taskDataList.filter(i => +i.professionalCompany === 5)).length && this.AdmittRuleForm.shippingType === '3') {
                        return this.$message.warning('城配订单时，发运类型不允许选择铁运');
                    }
                    const reg = /^(([1-9][0-9]{0,4})([.][0-9]{0,2})?|100000|100000.0|100000.00|0.0|0.00|0)$/;
                    if (AdmittRuleForm.payMethod && !AdmittRuleForm.prepaidAmount) {
                        this.$message.warning('请填写预付金额');
                        this.isButtonDisabled = true;
                    } else if (Number(AdmittRuleForm.prepaidAmount) && !AdmittRuleForm.payMethod) {
                        this.$message.warning('请填写预付方式');
                        this.isButtonDisabled = true;
                    } else if (Number(AdmittRuleForm.prepaidAmount) > Number(AdmittRuleForm.transportationCost)) {
                        this.$message.warning('预付金额不可大于运输成本');
                        this.isButtonDisabled = true;
                    } else if (AdmittRuleForm.infoFee && !reg.test(AdmittRuleForm.infoFee)) {
                        this.isButtonDisabled = true;
                        return this.$message.warning('信息费用不能大于十万');
                    } else if ((this.disableEdit || this.isSiteWhiteList) && this.siteType === '00' && !AdmittRuleForm.orderNo) {
                        return this.$message.warning('请选择调车单号');
                    } else {
                        const res = await getIsControlTransportToOpt({ supplierCode: AdmittRuleForm.supplierCode });
                        if (res && +res.code === 0 && +res.data.isControlTransport !== 1) { // 1：直控，0：非直控
                            if (this.isDirectControlFlag) {
                                this.reasonDialogVisible = true;
                                return false;
                            }
                            this.AdmittRuleForm.directlyControlledRecord = { reasonDialogVisible: false, directControlTransportCapacityFlag: false };
                        } else {
                            this.AdmittRuleForm.directlyControlledRecord = { reasonDialogVisible: false, directControlTransportCapacityFlag: true };
                        }
                        if (this.AdmittRuleForm.standardShippingType && this.AdmittRuleForm.shippingType !== this.AdmittRuleForm.standardShippingType) {
                            const msg = `当前系统判断发运类型为【${this.tmsShippingType[this.AdmittRuleForm.standardShippingType]}】，请确认修改为【${this.tmsShippingType[this.AdmittRuleForm.shippingType]}】符合实际业务场景`;
                            await this.$confirm(msg, '提示', {
                                confirmButtonText: '确认',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.continueAdmittOk();
                            }).catch(() => {});
                        } else {
                            this.continueAdmittOk();
                        }
                    }
                } else {
                    this.$emit('AdmittOk', { state: false, form: valid, data: {} });
                    return false;
                }
            });
        },
        continueAdmittOk () {
            this.isButtonDisabled = false;
            this.AdmittRuleForm['procurementChannel'] = this.siteType;
            if (this.siteType !== '00') {
                this.AdmittRuleForm.oilcardPayAmount = '';
                // 非自调车清空运输收入
                this.AdmittRuleForm.transportationIncome = '';
            }
            if (+this.AdmittRuleForm.shippingType !== 0) {
                delete this.AdmittRuleForm.ztbTransportFlag;
            }
            /* eslint-disable */
            const data = this.isSiteWhiteList ? Object.assign({ netDispatchNo: this.AdmittRuleForm.orderNo, ntpManagerReverseProcessFlag: this.ntpManagerReverseProcessFlag }, this.AdmittRuleForm) : Object.assign({ ntpManagerReverseProcessFlag: this.ntpManagerReverseProcessFlag }, this.AdmittRuleForm);
            if ((!this.AdmittRuleForm.vehicleCard || !this.AdmittRuleForm.driver) && this.AdmittRuleForm.isExpressCarrier!== 'Y') {
                data.preDispatchStrategy = 'CDCHC' //当采购渠道为车队长合车时，司机/车牌没填时，增加标识车队长合车预排标识
            }
             // 当采购渠道为以下时，清空默认的费率,清空运输成本
            if (['10', '20', '40', '42', '120', '171', '190', '200', '210'].includes(data.procurementChannel)) {
                data.taxRate = '';
                data.transportationCost = '';
            }
            /* eslint-enable */
            delete data.supplierCode;
            delete data.routeNoList;
            this.$emit('AdmittOk', { state: true, data });
        },
        // 打开调车单号高级搜索 弹窗
        openAdvanceDialog () {
            const param = {
                carrierName: this.AdmittRuleForm.carrierName,
                carrierCode: this.AdmittRuleForm.carrierCode,
                driverCodes: this.AdmittRuleForm.driverNo,
                forwardNtpDeploy: this.AdmittRuleForm.forwardNtpDeploy,
                carLicenses: [this.AdmittRuleForm.vehicleCard], // 车牌
                supplierCodes: [this.AdmittRuleForm.carrierCode] // 承运商编码
            };
            this.$refs.advanceDialog.show(true, this.carSchedulingDialog.advanceDialogConfig, param, '', [], '');
        },
        // 调车单号高级搜索 数据选中的回调
        confirm (data) {
            this.AdmittRuleForm.orderNo = data.orderNo;
            this.AdmittRuleForm.ntpManagerOrderNo = data.orderNo;
            this.NTPInfo.NTPDriverName = data.driverName;
            this.NTPInfo.NTPDriverCode = data.driverCode;
            this.NTPInfo.NTPCarLicense = data.carLicense;
            this.ntpManagerReverseProcessFlag = data.ntpManagerReverseProcessFlag;
            this.setTransUnitName(data);
            this.getTransportationCost(data);
        },
        // 获取运输成本
        getTransportationCost (data) {
            // 编辑时，后端需要
            ['freightType', 'quoteMode', 'driverUnitFreight', 'transportAmount', 'accountName', 'accountCode', 'contractCode'].forEach(key => {
                this.AdmittRuleForm[key] = data[key];
            });
            if (this.AdmittRuleForm.procurementChannel !== '00') {
                return false;
            }
            if (data.freightType === '3' || data.freightType === '0') { // 0:一口价(弃但兼容旧逻辑),1:竞价,3:一口价 新
                this.AdmittRuleForm.transportationCost = data.transportAmount;
            } else if (+data.freightType === 1) {
                const params = {
                    freightType: data.freightType,
                    quoteMode: data.quoteMode,
                    driverUnitFreight: data.driverUnitFreight,
                    transportAmount: data.transportAmount,
                    ntpManagerOrderNo: data.orderNo,
                    taskNos: this.taskDataList.map(v => v.taskNo)
                };
                getNtpManagerOrderComputerCostApi(params).then(res => {
                    if (res && +res.code === 0) {
                        this.AdmittRuleForm.transportationCost = res.data;
                    }
                }).catch(() => {
                    this.AdmittRuleForm.natureType = '';
                });
            }
        },
        // 调车单号高级搜索 数据清空的回调
        clearOrderNo () {
            if (this.AdmittRuleForm.orderNo) {
                this.AdmittRuleForm.orderNo = '';
            }
            if (+this.AdmittRuleForm.natureType === 1 && this.AdmittRuleForm.procurementChannel !== '00') {
                ['transUnitName', 'transUnitCode', 'transportContractNo'].forEach(key => {
                    this.AdmittRuleForm[key] = '';
                });
            }
            this.AdmittRuleForm.natureType = '';
        },
        whiteListCheck () {
            // 判断是否为零担干线公司(3)或零担干线-网络(4)或者城配公司(5)或生产物流(2)
            const updateShippingTypeTaskNos = [];
            this.taskDataList.forEach(item => {
                if ([2, 3, 4, 5].includes(+item.professionalCompany)) {
                    updateShippingTypeTaskNos.push(item.taskNo);
                }
            });
            if (updateShippingTypeTaskNos.length) {
                this.AdmittRuleForm.updateShippingTypeTaskNos = JSON.parse(JSON.stringify(updateShippingTypeTaskNos));
                return true;
            } else {
                return false;
            }
        },
        yiLaiKeSIiCheck () {
            if (this.taskDataList.some(v => v.sourceSystem === 'ELECTROLUX')) {
                return true;
            } else {
                return false;
            }
        },
        async isLingDan () {
            const params = {
                taskNos: this.taskDataList.map(v => v.taskNo),
                carrierCode: this.AdmittRuleForm.carrierCode,
                carrierName: this.AdmittRuleForm.carrierName,
                procurementChannel: this.AdmittRuleForm.procurementChannel
            };
            await isLingDanApi(params).then(res => {
                if (res && +res.code === 0) {
                    this.AdmittRuleForm.shippingType = '';// 清空发运类型
                    if (res.data === 2) {
                        // 当承运商为快递，且零担没打标时，默认发运类型为快递
                        if (this.AdmittRuleForm.isExpressCarrier === 'Y') {
                            this.AdmittRuleForm.shippingType = '4';
                        }
                        return false; // 返回2时，默认为空
                    }
                    this.AdmittRuleForm.shippingType = res.data + '';
                    this.AdmittRuleForm.standardShippingType = res.data + '';
                }
            });
        },
        // 判断装载率是否小于50%
        judgeLoadRateLessHalf () {
            const type = 'dispatch';
            if (!this.AdmittRuleForm.vehicleCard || !this.AdmittRuleForm.procurementChannel) return;
            const params = {
                procurementChannel: this.AdmittRuleForm.procurementChannel,
                taskNoList: this.taskDataList.map(v => v.taskNo),
                carrierCode: this.AdmittRuleForm.carrierCode,
                licensePlateNo: this.AdmittRuleForm.vehicleCard,
                operateFlag: type
            };
            verifyLoadingRate(params).then(res => {
                this.loadRateHalf = 'normal';
                const lowercaseData = {};
                if (res && +res.code === 0 && res.data) {
                    // 考虑有大小写混写全部转小写
                    for (const key in res.data) {
                        if (Object.hasOwnProperty.call(res.data, key)) {
                            lowercaseData[key.toLowerCase()] = res.data[key];
                        }
                    }
                    if (lowercaseData[type] && lowercaseData[type].passFlag === false) {
                        // 当排车标识的装载率低于50%
                        this.loadRateHalf = 'lesser';
                        const tipFlag = !this.AdmittRuleForm.exceptionType || !this.AdmittRuleForm.exceptionMark;
                        const percent = lowercaseData[type].minLoadRate ? lowercaseData[type].minLoadRate + '%' : '规定值';
                        // 只要没值，有可能选择修改车牌被清空有可能是回显没值都提示，有值就不用提示
                        tipFlag && this.$message({
                            message: `装载率低于${percent}请选择装载率过低异常类型、填写备注`,
                            showClose: true,
                            type: 'warning'
                        });
                    } else {
                        // 请求成功就清空，但是第一次回显保留
                        this.AdmittRuleForm.exceptionMark = '';
                        this.AdmittRuleForm.exceptionType = '';
                        this.loadRateHalf = 'greater';
                    }
                }
            });
        },
        // 赋值
        setData () {
            // eslint-disable-next-line max-len
            ['standardCost', 'iflowStatus', 'iflowLink', 'driverIdentity', 'carrierName', 'carrierCode', 'procurementChannel', 'vehicleCard', 'deviceNo', 'vehicleScheduleName', 'companyCode', 'driverNo', 'equipmentName', 'equipmentType', 'besArriveDate', 'driver', 'driverContactWay', 'transportationCost', 'payMethod', 'prepaidAmount', 'infoFee', 'remark', 'exceptionType', 'exceptionMark', 'oilcardPayAmount', 'planRemark', 'dispatchType', 'onWayContactCategory', 'onWayContactName', 'onWayContactPhone', 'transUnitName', 'transUnitCode', 'totalTargetCost', 'equipmentTypeMapping', 'forceChuanDian', 'dispatchChannel', 'expressNo', 'transportationIncome', 'ztbTransportFlag', 'siteCode', 'paymentTerms', 'transportContractNo', 'natureType', 'propertyNature', 'tyCarTypeName', 'tyOutputTime'].forEach(key => {
                this.AdmittRuleForm[key] = this.dataLists[key];
            });
            if (typeof this.dataLists.ztbTransportFlag === 'undefined' || this.dataLists.ztbTransportFlag !== 0) {
                this.AdmittRuleForm.ztbTransportFlag = 1;
            }
            this.siteType = this.dataLists.procurementChannel; // 采购渠道
            this.AdmittRuleForm.siteCodeList = this.siteCodeList;
            this.AdmittRuleForm.forwardNtpDeploy = +this.dataLists.dispatchType !== 6;
            // 如果运力经理人任务单号存在 并且 该服务平台为白名单 赋值给调车单号 并获取NTP调车信息（网络调车排车页面触发）
            if (this.dataLists.ntpManagerOrderNo) {
                this.AdmittRuleForm.orderNo = this.dataLists.ntpManagerOrderNo || '';
                this.AdmittRuleForm.netDispatchNo = this.dataLists.ntpManagerOrderNo || '';
            }
            // 如果调车单号存在 编辑时 赋值（发车单调整页面触发）
            if (this.dataLists.netDispatchNo) {
                this.AdmittRuleForm.orderNo = this.dataLists.netDispatchNo || '';
                const params = {
                    driverCodes: [this.dataLists.driverNo],
                    orderNos: [this.AdmittRuleForm.orderNo],
                    carLicenses: [this.AdmittRuleForm.vehicleCard], // 车牌
                    supplierCodes: [this.AdmittRuleForm.carrierCode], // 承运商编码
                    forwardNtpDeploy: this.AdmittRuleForm.forwardNtpDeploy
                };
                getOrderNo(params).then(res => {
                    if (res && +res.code === 0) {
                        this.orderNoList = res.data.list || [];
                        if (this.orderNoList.length) {
                            const data = this.orderNoList[0];
                            this.NTPInfo.NTPDriverName = data.driverName;
                            this.NTPInfo.NTPDriverCode = data.driverCode;
                            this.NTPInfo.NTPCarLicense = data.carLicense;
                            this.setTransUnitName(data);
                        }
                    }
                });
            } else {
                getOrderNo({ driverCodes: [this.dataLists.driverNo],
                    forwardNtpDeploy: this.AdmittRuleForm.forwardNtpDeploy,
                    carLicenses: [this.AdmittRuleForm.vehicleCard],
                    supplierCodes: [this.AdmittRuleForm.carrierCode] }).then(res => {
                    if (res && +res.code === 0) {
                        this.orderNoList = res.data.list || [];
                    }
                });
            }
            if (this.dataLists.hasOwnProperty('ntpManagerReverseProcessFlag')) {
                this.ntpManagerReverseProcessFlag = this.dataLists.ntpManagerReverseProcessFlag;
            }
            this.AdmittRuleForm.conveniently = this.dataLists.conveniently ? String(this.dataLists.conveniently) : '0';
            if (this.AdmittRuleForm.taxRate === '' && this.dataLists.taxRate === undefined) {
                this.dataLists.taxRate = '';
            }
            this.AdmittRuleForm.taxRate = String(this.dataLists.taxRate) ? String(this.dataLists.taxRate) : '9';// 默认为9
            this.AdmittRuleForm.dmsFlag = ['42', '190', '200'].includes(this.AdmittRuleForm.procurementChannel) ? '1' : '0';
            this.AdmittRuleForm.remark = this.dataLists.remark;
            this.AdmittRuleForm.supplierCode = this.dataLists.carrierCode;
            if (this.AdmittRuleForm.payMethod === '网银转账') {
                this.AdmittRuleForm.payMethod = '0';
            } else if (this.AdmittRuleForm.payMethod === '油卡支付') {
                this.AdmittRuleForm.payMethod = '1';
            }
            this.AdmittRuleForm.whName = this.dataLists.wtWhCode;
            this.AdmittRuleForm.transportType = this.dataLists.transportType || '00';
            const { onWayContactCategory, onWayContactName, onWayContactPhone } = this.AdmittRuleForm;
            // 获取承运商主体类型属性
            if (this.dataLists.carrierCode || this.taskDataList.length) {
                getSearchBySupplier({
                    pageNo: 1,
                    pageSize: 10,
                    supplierCode: this.dataLists.carrierCode || this.taskDataList[0].carrierCode,
                    professionalCompanyList: this.professionalCompanyList,
                    taskNoList: this.taskNoList,
                    siteCodeList: this.siteCodeList,
                    supplierStatus: '30',
                    businessTypeStatus: '5'
                }).then(res => {
                    if (res.data.list.length) {
                        this.AdmittRuleForm.propertyNature = res.data.list[0].propertyNature;
                        this.AdmittRuleForm.procurementChannelFlag = res.data.list[0].whiteList;
                    }
                    if (onWayContactCategory && onWayContactName && onWayContactPhone) {
                        this.AdmittRuleForm.newOnWayContact = false;
                        this.intranetInformationFlag = true;
                        this.informationFlag = true;
                    }
                });
            }
            if (+this.dataLists.shippingType === 0) {
                this.AdmittRuleForm.shippingType = '0';
            } else if (this.dataLists.shippingType) {
                this.AdmittRuleForm.shippingType = this.dataLists.shippingType + '';
            }
            if (+this.dataLists.originDispatchStatus === 6 && this.AdmittRuleForm.carrierName) {
                this.isLingDan();
            }
            if (!this.disableEdit && !this.isPlanArrange) { // 网络调车排车、计划排车不需要调这个接口
                this.getJudgeExpress();
            }
            // 编辑时候回显走一次查询
            this.AdmittRuleForm.procurementChannel === '00' && this.setTransportationIncome(true);
        },
        getOutContractIncome() {
            this.fetchTransportationIncome = '';
            getOutContractIncomeApi(this.taskNoList).then((res) => {
                // 后端返回0就是没审批值，有值才赋值
                if (res && +res.code === 0 && res.data) {
                    this.AdmittRuleForm.transportationIncome = res.data;
                    this.fetchTransportationIncome = res.data;
                }
            });
        },
        // 获取运输收入
        setTransportationIncome(first = false) {
            // 编辑回显this.dataLists.transportationIncome有值有值时候不调接口改变，沿用回显值
            if (first) {
                if (+this.dataLists.transportationIncome !== 0 && !this.dataLists.transportationIncome) {
                    this.getOutContractIncome();
                }
            } else {
                // 承运商变动重新查询赋值
                this.getOutContractIncome();
            }
        },
        clearClick (carrierName) {
            if (!carrierName) {
                this.AdmittRuleForm.driverContactWay = '';
                this.AdmittRuleForm.equipmentName = '';
            }
        },
        /**
         * @desc 获取多仓提货补贴服务平台白名单或者采购渠道配置或者直控线路串点计费模式服务平台白名单
         */
        async getSiteCodeWhiteList ({ type, key }) {
            await getWhiteListApi({ type }).then(res => {
                if (res && +res.code === 0) {
                    this[key] = res.data;
                }
            });
        },
        /**
         * @desc 获取自调车会计主体配置
         */
        async getUnit () {
            const dic = await dictWithUrl('UNIT_NAME,TRANSPORT_COST_DISABLED,TMS_SHIPPING_TYPE');
            if (dic && +dic.code === 0) {
                const UNIT_NAME = dic.data.UNIT_NAME;
                const now = new Date().getTime();
                for (const key in UNIT_NAME) {
                    if (now > new Date(key.toString()).getTime()) {
                        this.unit = JSON.parse(UNIT_NAME[key]);
                    }
                }
                this.transportationCostDisabledFlag = dic.data.TRANSPORT_COST_DISABLED.transportationCostDisabledFlag === 'true';
                this.tmsShippingType = dic.data.TMS_SHIPPING_TYPE;
            }
        },
        timeChange () {
            if (!this.AdmittRuleForm.tyOutputTime) return;
            const year = new Date().getFullYear();
            const month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1; ;
            const day = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate();
            let startTime = '';
            let warngMes = '';
            if (this.dataLists.tyOutputTime) {
                startTime = this.dataLists.createTime.split(' ')[0];
            } else {
                startTime = `${year}-${month}-${day}`;
            }
            warngMes = `预约到厂日期的可选择范围为：${startTime}的后3个工作日内`;
            const endTime = this.AdmittRuleForm.tyOutputTime.split(' ')[0] || 0;
            const timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
            if (timeDifference > 3 * 24 * 60 * 60 * 1000 || timeDifference < 0) {
                this.AdmittRuleForm.tyOutputTime = this.dataLists.tyOutputTime;
                return this.$message.warning(warngMes);
            }
        }
    },
    async created () {
        this.AdmittRuleForm.professionalCompanyList = this.professionalCompanyList;// 承运商查询默认入参
        this.AdmittRuleForm.siteCodeList = this.siteCodeList;// 承运商查询默认入参
        this.AdmittRuleForm.taskNoList = this.taskNoList;// 承运商查询默认入参
        this.setData();
        await this.getUnit();
        if ((this.dataLists.carrierCode || this.AdmittRuleForm.carrierCode) && this.AdmittRuleForm.procurementChannelFlag) { // 获取可选采购渠道
            this.getProcurementChannelList(this.dataLists.carrierCode || this.AdmittRuleForm.carrierCode);
        }
        this.inOutTypeCheck = this.taskDataList.length > 0 ? this.taskDataList[0].inOutType : '';
        this.getTotalTargetCost();// 获取目标成本
        await this.getSiteCodeWhiteList({ type: 'MULTI_LOAD_SITE_CODE', key: 'siteCodeWhiteList' });// 获取多仓提货补贴服务平台白名单
        await this.getSiteCodeWhiteList({ type: 'DMS_PROCUREMENT_CHANNEL', key: 'procurementChannelWhiteList' });// 获取串点计费里程时，采购渠道配置
        await this.getSiteCodeWhiteList({ type: 'DC_DMS_RULE_SITE_CODE', key: 'forceChuanDianSiteCodeList' });// 直控线路串点计费模式服务平台白名单
        // 判断 服务平台是否为白名单内
        !this.isPlanArrange && await isSiteWhiteListApi(this.taskDataList[0].siteCode).then(res => {
            if (res && +res.code === 0) {
                this.isSiteWhiteList = res.data;
            }
        });
        // 判断是否为白名单内，是，根据接口获取承运商配置
        this.taskDataList.forEach(i => {
            if (this.siteCodeWhiteList.includes(i.siteCode)) {
                this.procurementChannelList = this.procurementChannelWhiteList;
                return false;
            }
        });
    },
    watch: {
        'AdmittRuleForm.carrierName': {
            deep: true,
            handler: function (newVal, oldVal) {
                if ((newVal !== oldVal) && (this.dataLists.carrierName !== this.AdmittRuleForm.carrierName)) {
                    ['vehicleCard', 'driver', 'equipmentName', 'besArriveDate', 'driverContactWay',
                        'transportationCost', 'payMethod', 'prepaidAmount', 'infoFee'
                    ].forEach(key => {
                        this.AdmittRuleForm[key] = '';
                    });
                    this.AdmittRuleForm.forceChuanDian = 0;
                }
            }
        },
        'AdmittRuleForm.vehicleCard' (newVal, oldVal) {
            if (newVal) {
                this.judgeLoadRateLessHalf();
            } else {
                this.loadRateHalf = 'normal';
            }
        },
        taskDataList: {
            handler: function (newVal, oldVal) {
                // 去重
                const duplicateRemovalTaskDataList = _.unionWith(newVal, (item1, item2) => {
                    return item1.siteCode === item2.siteCode && item1.companyCode === item2.companyCode && item1.businessType === item2.businessType;
                });
                // 组装获取会计主体所需的入参
                this.AdmittRuleForm.taskDataList = duplicateRemovalTaskDataList.map(item => {
                    const { siteCode, companyCode, businessType, carrierCode } = item;
                    return {
                        siteCode, companyCode, businessType, suppliersCode: carrierCode
                    };
                });
                this.AdmittRuleForm.checkResource = false;
                newVal.forEach(i => {
                    if (i.inOutTypeCheck === 'OUT' || i.inOutType === 'YS') {
                        this.AdmittRuleForm.checkResource = true;
                        return false;
                    }
                });
            },
            deep: true,
            immediate: true
        },
        siteType(newVal) {
            if (newVal === '00') {
                this.setTransportationIncome();
            }
        }
    },
    computed: {
        show: {
            set (val) { this.$emit('update:RwCarVisiable', val); },
            get () { return this.RwCarVisiable; }
        },
        inOutTypeName() {
            return this.inOutType;
        },
        forceChuanDianShowCheck () {
            // 只有物流公司(20) 和车队供应商(40)，才显示串点计费
            return (this.siteType === '20' || this.siteType === '40');
        },
        convenientlyDisabledCheck () { // 是否顺路带回可编辑判断
            return ((this.inOutType === 'IN' || this.inOutTypeCheck === 'IN') &&
                    (['190', '200'].includes(this.AdmittRuleForm.procurementChannel) || +this.AdmittRuleForm.forceChuanDian === 1))
                ? !this.isConvenientlyLists : this.isConvenientlyLists;
        },
        isDirectControlFlag () {
            return this.taskDataList.some(i => +i.directControlFlag === 1);
        },
        professionalCompanyList () {
            return [...new Set(this.taskDataList.map(i => i.professionalCompany))];
        },
        siteCodeList () {
            return [...new Set(this.taskDataList.map(i => i.siteCode))];
        },
        taskNoList () {
            return this.taskDataList.map(i => i.taskNo);
        },
        driverPropCheck () {
            // 采购渠道为车队长合车、车队供应商 || 是快递公司时，司机、车牌非必填,不是快递公司时转移新建都必填
            return (![40, 42].includes(+this.AdmittRuleForm.procurementChannel) || this.dataLists.carrierName || this.AdmittRuleForm.carRequire) && this.AdmittRuleForm.isExpressCarrier !== 'Y';
        },
        forceChuanDianDisabled () {
            const forceChuanDianSiteCodeList = this.taskDataList.every(i => this.forceChuanDianSiteCodeList.includes(i.siteCode));
            const scPosFlag = this.taskDataList.every(v => +v.scPosFlag === 1);
            return (forceChuanDianSiteCodeList && scPosFlag);
        },
        transUnitNameDisabled() {
            return +this.AdmittRuleForm.natureType === 1;
        },
        transportationCostDisabled () {
            return this.AdmittRuleForm.natureType === '0' && this.AdmittRuleForm.procurementChannel === '00' && this.transportationCostDisabledFlag;
        },
        isTy () {
            return (+this.dataLists.tyReservationFlag === 1 || this.taskDataList.some(i => +i.tyReservationFlag === 1)) && !this.isAlgorithmicType;
        }
    }
};
</script>

<style lang="less">
@import './carSchedulingDialog/carSchedulingDialog.less';
.dispatch-center-car-scheduling {
    .el-picker-panel__footer {
        .el-button--text {
            display: none;
        }
    }
}
// 算法排车装载类低卡控，写在里面外层用confirm自定样式类名对应，即可统一装载率低弹窗样式
.low-loading-rate-class{
    .el-message-box__header {
        .el-message-box__title{
            color: red;
        }
    }
    .el-message-box__content {
      color: red;
    }
    .el-message-box__btns{
        .el-button {
            padding: 7px 15px;
            border-radius: 4px;
        }
    }
}

</style>
